// extracted by mini-css-extract-plugin
export default {"container":"Form_container__7FBja","head":"Form_head__0QDxw","email":"Form_email__bvkEZ","btn":"Form_btn__YKEho","googl":"Form_googl__oe8S1","lk":"Form_lk__13H8P"};